/** act: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "quoted": "“{v}”",
  "signedIn": "Signed in",
  "createdCampaign": "Created campaign {name}",
  "createdPlaylist": "Created playlist {name}",
  "createdApp": "Created app {name}",
  "added": "Added {name}",
  "uploaded": "Uploaded {name}",
  "renamed": "Renamed {from} to {to}",
  "savedCampaign": "Saved campaign {name}",
  "savedPlaylist": "Saved playlist {name}",
  "appSettings": "Changed the settings of app {name}",
  "deleted": "Deleted {name}",
  "restricted": "Restricted {name} on all players",
  "muted": "Muted {name} on all players",
  "unmuted": "Unmuted {name}",
  "unrestricted": "Removed the restriction on {name}",
  "attributes": "Edited the custom attributes of {name}",
  "customAppAdded": "Added the custom app {name}",
  "customAppDeleted": "Deleted the custom app {name}",
  "customAppEdited": "Edited the custom app {name}",
  "versionCurrent": "Made version {n} of {name} current",
  "versionUploaded": "Uploaded version {n} of {name}",
  "appUpdated": "App updated from {from} to {to}",
  "contentApplied": "Started playing content revision {rev}",
  "restarted": "The player restarted",
  "wentOffline": "The player went offline",
  "backOnline": "The player is back online",
  "escalated": "Now {sev}: {msg}",
  "resolved_PLAYER_OFFLINE": "The player is back online",
  "resolved_PLAYER_NEVER_CONNECTED": "The player connected for the first time",
  "resolved_PLAYER_OUT_OF_SYNC": "The player is playing the latest content",
  "resolved_PLAYER_FALLBACK": "The player stopped showing fallback content",
  "resolved_PLAYER_NOT_ON_SCREEN": "The player is back on screen",
  "resolved_PLAYER_FILES_FAILED": "All content files are downloaded and verified",
  "resolved_PLAYER_STORAGE_LOW": "Storage is no longer low",
  "resolved_PLAYER_ERROR_SPIKE": "The error rate is back to normal",
  "resolved_PLAYER_APP_OUTDATED": "The app is up to date",
  "resolved_PLAYER_NO_CONTENT": "The player has content to play again",
  "resolved_PLAYER_LOCATION_MISSING": "Location issue resolved",
  "resolved_CAMPAIGN_EMPTY_ZONE": "No empty sections any more",
  "resolved_PLAYLIST_EMPTY": "The playlist has items again",
  "resolved_MEDIA_FAILED": "The failed item was fixed or removed",
  "resolved_PUBLICATION_EXPIRED": "The expired publication was changed or removed",
  "resolved_FEED_FAILING": "The data feed’s source can be read again",
  "resolved_CONTENT_BROKEN": "Players can download and play the item again",
  "resolved_MEDIA_FILE_MISSING": "The item's file can be reached again",
  "resolved_PLAYER_CANT_DOWNLOAD": "Downloads work again",
  "resolved_PLAYER_CONTENT_REJECTED": "The player accepted the new content",
  "feedCreated": "Created the data feed {name}",
  "feedEdited": "Edited the data feed {name}",
  "feedDeleted": "Deleted the data feed {name}",
  "feedApproved": "Approved an update of {name} ({changes})",
  "feedRejected": "Rejected an update of {name}",
  "feedChanged": "New data in {name} ({changes})",
  "feedPending": "An update of {name} waits for approval ({changes})",
  "groupCreated": "Created player group {name}",
  "groupDeleted": "Deleted player group {name}",
  "groupRenamed": "Renamed player group {from} to {to}",
  "groupTags": "Set the tags of group {name} to {tags}",
  "noTags": "none",
  "invited": "Invited {email} as {role}",
  "inviteRevoked": "Revoked the invitation for {email}",
  "roleChanged": "Changed {name} from {from} to {to}",
  "memberRemoved": "Removed {name} from the organization",
  "memberLeft": "Left the organization",
  "playerAdded": "Added player {name}",
  "playerDeleted": "Deleted player {name}",
  "playerEdited": "Edited player {name}",
  "playerTags": "Set the tags of player {name} to {tags}",
  "playerAttributes": "Edited the custom attributes of {name}",
  "loopOn": "Turned loop on on player {name}",
  "loopOff": "Turned loop off on player {name}",
  "published": "Published {content} ({n} player reached) | Published {content} ({n} players reached)",
  "unpublishedTag": "Unpublished {name} from tag #{tag} ({n} player) | Unpublished {name} from tag #{tag} ({n} players)",
  "reordered": "Reordered the content of {owner}",
  "regionCreated": "Created region {name}",
  "regionEdited": "Edited region {name}",
  "regionDeleted": "Deleted region {name}",
  "tagRenamed": "Renamed tag #{from} to #{to}",
  "tagMerged": "Merged tag #{from} into #{to}",
  "tagDeleted": "Deleted tag #{name}",
  "tagAdded": "Added tag #{name} to {players} player(s) and {groups} group(s)",
  "tagRemoved": "Removed tag #{name} from {players} player(s) and {groups} group(s)",
  "reportCreated": "Created report {name}",
  "reportScheduled": "Created recurring report {name}",
  "reportEdited": "Edited report {name}",
  "reportDeleted": "Deleted report {name}",
  "reportRun": "Ran report {name}",
  "reportFailed": "Report {name} failed: {error}",
  "alertCreated": "Created alert {name}",
  "alertEdited": "Edited alert {name}",
  "alertOff": "Turned off alert {name}",
  "alertDeleted": "Deleted alert {name}",
  "alertTriggered": "Alert {name} triggered",
  "alertTriggeredValue": "Alert {name} triggered ({value})",
  "alertResolved": "Alert {name} resolved",
  "orgRenamed": "Renamed the organization from {from} to {to}",
  "countrySet": "Set the organization’s country to {country}",
  "countryCleared": "Cleared the organization’s country",
  "defaults": "Changed the organization’s Player defaults",
  "thresholds": "Changed Health Check thresholds",
  "playerSettings": "Changed the Player Settings of {name}",
  "attrCreatedPlayer": "Created the player attribute {name}",
  "attrCreatedContent": "Created the content attribute {name}",
  "attrEditedPlayer": "Edited the player attribute {name}",
  "attrEditedContent": "Edited the content attribute {name}",
  "attrDeletedPlayer": "Deleted the player attribute {name} and its values",
  "attrDeletedContent": "Deleted the content attribute {name} and its values"
};
const ar: typeof en = {
  "quoted": "«{v}»",
  "signedIn": "سجّل الدخول",
  "createdCampaign": "أنشأ الحملة {name}",
  "createdPlaylist": "أنشأ قائمة التشغيل {name}",
  "createdApp": "أنشأ التطبيق {name}",
  "added": "أضاف {name}",
  "uploaded": "رفع {name}",
  "renamed": "أعاد تسمية {from} إلى {to}",
  "savedCampaign": "حفظ الحملة {name}",
  "savedPlaylist": "حفظ قائمة التشغيل {name}",
  "appSettings": "غيّر إعدادات التطبيق {name}",
  "deleted": "حذف {name}",
  "restricted": "قيّد {name} على كل المشغلات",
  "muted": "كتم {name} على كل المشغلات",
  "unmuted": "إلغاء كتم {name}",
  "unrestricted": "أزال القيد عن {name}",
  "attributes": "عدّل السمات المخصصة لـ {name}",
  "customAppAdded": "أضاف التطبيق المخصص {name}",
  "customAppDeleted": "حذف التطبيق المخصص {name}",
  "customAppEdited": "عدّل التطبيق المخصص {name}",
  "versionCurrent": "جعل الإصدار {n} من {name} حاليًا",
  "versionUploaded": "رفع الإصدار {n} من {name}",
  "appUpdated": "تم تحديث التطبيق من {from} إلى {to}",
  "contentApplied": "بدأ عرض نسخة المحتوى {rev}",
  "restarted": "أُعيد تشغيل المشغل",
  "wentOffline": "انقطع اتصال المشغل",
  "backOnline": "عاد المشغل متصلًا",
  "escalated": "أصبحت {sev}: {msg}",
  "resolved_PLAYER_OFFLINE": "عاد المشغل متصلًا",
  "resolved_PLAYER_NEVER_CONNECTED": "اتصل المشغل لأول مرة",
  "resolved_PLAYER_OUT_OF_SYNC": "يعرض المشغل أحدث محتوى",
  "resolved_PLAYER_FALLBACK": "توقف المشغل عن عرض المحتوى الاحتياطي",
  "resolved_PLAYER_NOT_ON_SCREEN": "عاد المشغل إلى الشاشة",
  "resolved_PLAYER_FILES_FAILED": "تم تنزيل كل ملفات المحتوى والتحقق منها",
  "resolved_PLAYER_STORAGE_LOW": "لم تعد مساحة التخزين منخفضة",
  "resolved_PLAYER_ERROR_SPIKE": "عاد معدل الأخطاء إلى طبيعته",
  "resolved_PLAYER_APP_OUTDATED": "التطبيق محدّث",
  "resolved_PLAYER_NO_CONTENT": "لدى المشغل محتوى للعرض مجددًا",
  "resolved_PLAYER_LOCATION_MISSING": "حُلّت مشكلة الموقع",
  "resolved_CAMPAIGN_EMPTY_ZONE": "لم تعد هناك أقسام فارغة",
  "resolved_PLAYLIST_EMPTY": "أصبحت في قائمة التشغيل عناصر مجددًا",
  "resolved_MEDIA_FAILED": "أُصلح العنصر الفاشل أو أُزيل",
  "resolved_PUBLICATION_EXPIRED": "تم تغيير النشر المنتهي أو إزالته",
  "resolved_FEED_FAILING": "يمكن قراءة مصدر البيانات مجددًا",
  "resolved_CONTENT_BROKEN": "يمكن للمشغلات تنزيل العنصر وتشغيله مجددًا",
  "resolved_MEDIA_FILE_MISSING": "يمكن الوصول إلى ملف العنصر مجددًا",
  "resolved_PLAYER_CANT_DOWNLOAD": "عاد التنزيل للعمل",
  "resolved_PLAYER_CONTENT_REJECTED": "قبِل المشغّل المحتوى الجديد",
  "feedCreated": "أنشأ مصدر البيانات {name}",
  "feedEdited": "عدّل مصدر البيانات {name}",
  "feedDeleted": "حذف مصدر البيانات {name}",
  "feedApproved": "وافق على تحديث {name} ({changes})",
  "feedRejected": "رفض تحديث {name}",
  "feedChanged": "بيانات جديدة في {name} ({changes})",
  "feedPending": "تحديث {name} بانتظار الموافقة ({changes})",
  "groupCreated": "أنشأ مجموعة المشغلات {name}",
  "groupDeleted": "حذف مجموعة المشغلات {name}",
  "groupRenamed": "أعاد تسمية مجموعة المشغلات {from} إلى {to}",
  "groupTags": "ضبط وسوم المجموعة {name} إلى {tags}",
  "noTags": "لا شيء",
  "invited": "دعا {email} بصفة {role}",
  "inviteRevoked": "ألغى الدعوة الموجّهة إلى {email}",
  "roleChanged": "غيّر دور {name} من {from} إلى {to}",
  "memberRemoved": "أزال {name} من المؤسسة",
  "memberLeft": "غادر المؤسسة",
  "playerAdded": "أضاف المشغل {name}",
  "playerDeleted": "حذف المشغل {name}",
  "playerEdited": "عدّل المشغل {name}",
  "playerTags": "ضبط وسوم المشغل {name} إلى {tags}",
  "playerAttributes": "عدّل السمات المخصصة لـ {name}",
  "loopOn": "شغّل التكرار على المشغل {name}",
  "loopOff": "أوقف التكرار على المشغل {name}",
  "published": "نشر {content} (لم يصل إلى أي مشغل) | نشر {content} (وصل إلى مشغل واحد) | نشر {content} (وصل إلى مشغلين) | نشر {content} (وصل إلى {n} مشغلات) | نشر {content} (وصل إلى {n} مشغلًا) | نشر {content} (وصل إلى {n} مشغل)",
  "unpublishedTag": "ألغى نشر {name} من الوسم #{tag} (لا مشغلات) | ألغى نشر {name} من الوسم #{tag} (مشغل واحد) | ألغى نشر {name} من الوسم #{tag} (مشغلان) | ألغى نشر {name} من الوسم #{tag} ({n} مشغلات) | ألغى نشر {name} من الوسم #{tag} ({n} مشغلًا) | ألغى نشر {name} من الوسم #{tag} ({n} مشغل)",
  "reordered": "أعاد ترتيب محتوى {owner}",
  "regionCreated": "أنشأ المنطقة {name}",
  "regionEdited": "عدّل المنطقة {name}",
  "regionDeleted": "حذف المنطقة {name}",
  "tagRenamed": "أعاد تسمية الوسم #{from} إلى #{to}",
  "tagMerged": "دمج الوسم #{from} في #{to}",
  "tagDeleted": "حذف الوسم #{name}",
  "tagAdded": "أضاف الوسم #{name} إلى {players} مشغل و{groups} مجموعة",
  "tagRemoved": "أزال الوسم #{name} من {players} مشغل و{groups} مجموعة",
  "reportCreated": "أنشأ التقرير {name}",
  "reportScheduled": "أنشأ التقرير المتكرر {name}",
  "reportEdited": "عدّل التقرير {name}",
  "reportDeleted": "حذف التقرير {name}",
  "reportRun": "شغّل التقرير {name}",
  "reportFailed": "فشل التقرير {name}: {error}",
  "alertCreated": "أنشأ التنبيه {name}",
  "alertEdited": "عدّل التنبيه {name}",
  "alertOff": "أوقف التنبيه {name}",
  "alertDeleted": "حذف التنبيه {name}",
  "alertTriggered": "أُطلق التنبيه {name}",
  "alertTriggeredValue": "أُطلق التنبيه {name} ({value})",
  "alertResolved": "زال التنبيه {name}",
  "orgRenamed": "أعاد تسمية المؤسسة من {from} إلى {to}",
  "countrySet": "ضبط دولة المؤسسة إلى {country}",
  "countryCleared": "مسح دولة المؤسسة",
  "defaults": "غيّر الإعدادات الافتراضية لمشغلات المؤسسة",
  "thresholds": "غيّر حدود فحص الحالة",
  "playerSettings": "غيّر إعدادات المشغل {name}",
  "attrCreatedPlayer": "أنشأ سمة المشغل {name}",
  "attrCreatedContent": "أنشأ سمة المحتوى {name}",
  "attrEditedPlayer": "عدّل سمة المشغل {name}",
  "attrEditedContent": "عدّل سمة المحتوى {name}",
  "attrDeletedPlayer": "حذف سمة المشغل {name} وقيمها",
  "attrDeletedContent": "حذف سمة المحتوى {name} وقيمها"
};
export default { en, ar };
